<template>
  <div id="page-location-view">
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData"/>
    <add-camera-sidebar :isSidebarActive="addNewCameraSidebar" @closeSidebar="toggleCameraSidebar" :data="cameraSidebarData" />
    <edit-camera-sidebar :isSidebarActive="addNewCameraDataSidebar" @getdata="getdata" @closeSidebar="toggleEditCameraDataSidebar" :data="sidebarEditCameraData" />
    <vs-alert color="danger" title="Location Not Found" :active.sync="user_not_found">
      <span>Location record with id: {{ $route.params.locationId }} not found. </span>
      <span>
      </span>
    </vs-alert>
       <vs-popup fullscreen title="" :active.sync="popupActive">
    <div id="page-camera-view" >
    <iframe  width="100%" height="490" class="center" :src="reset" allowfullscreen></iframe>
  </div>
      </vs-popup>
    <div id="user-data" v-if="location">
      <vx-card>
      <span >
      <h4  class="mb-base">{{location.name}}</h4>
      </span>
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->
          <div class="vx-col" id="avatar-col">
             <div class="img-container mb-2">
              <p class="rounded w-full bg-primary text-white" @click.stop="editStudentData(location)" :data-letters=location.name[0].toUpperCase()></p>
            </div>
          </div>
          <!-- Information - Col 1 -->
          <div class="vx-col" id="account-info-col-1">
            <table>
            <tr>
              <td>Timezone</td>
             </tr>
               <tr>
                <td>{{ location.timezone.name }}</td>
              </tr>
            </table>
           </div>
             <div class="vx-col" id="account-info-col-1">
            <table>
            <tr>
              <td>Managers</td>
             </tr>
              <tr>
              <td v-if="location.managers.length == 0">No Manager</td>
              <td v-else>
              <div  v-for="(manager, index) in location.managers" :key="index">
               <vs-chip    color="primary" >
              <vs-avatar  />
               <p  class="text-inherit"> {{ manager.fname }} {{ manager.lname }}</p>
               </vs-chip>
              </div></td>
              </tr>
            </table>
           </div>
                <div class="vx-col flex-1" id="account-info-col-1">
            <table>
            <tr>
              <td>Rooms</td>
             </tr>
              <tr>
              <td v-if="rooms.length == 0">No Rooms</td>
              <td v-else>
              <div  v-for="(room, index) in rooms" :key="index">
               <vs-chip    color="primary" >
               <p  class="text-inherit"> {{ room.name }}</p>
               </vs-chip>
              </div></td>
              </tr>
            </table>
           </div>
     
             <div class="vx-col " id="account-info-col-2">
            <table>
            <tr>
            <td>Schedule</td>
             </tr>
             <tr>
              <td v-if="location.schedule">
                   <div v-for="scheduledate in location.schedule.scheduledates" :key="scheduledate.id">
                <span>
                {{ scheduledate.day + ' : '}}
                {{ scheduledate.start_time | formatTime }}   {{ scheduledate.end_time | formatTime }}
                </span>
              </div>
              </td>
              <td v-else>No Schedule</td>
            </tr>
            <tr v-if="location.schedule">
              <td><vs-button size="small" @click.stop="confirmApplySchedule(location)" >Apply to All Cameras</vs-button></td>
            </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4"  @click="editData(location)">Edit</vs-button>
            <vs-button type="border" color="danger" icon-pack="feather" icon="icon-trash" @click="confirmDeleteRecord(location)">Delete</vs-button>
          </div>
        </div>
      </vx-card>
      </div>
        <div class="flex flex-wrap-reverse items-center data-list-btn-container mt-5">
       <h3 class="ml-5">Cameras</h3>
          <!-- ADD NEW -->
          <div class="btn-add-new p-3 ml-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addCameraData(location)">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>
          <p v-if="location.cameras.length==0" class="ml-5 text-left mt-5">No camera associate to this location</p>
       <div   v-if="location.cameras.length>0" class="data-list-container p-6">  
       <vs-table ref="table"  :data="location.cameras"> 
        <template slot="thead">
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="code">Code</vs-th>
        <vs-th sort-key="location">Camera ID</vs-th>
        <vs-th sort-key="color_code">Color</vs-th>
      </template>
       <template  slot-scope="{data}">
          <tbody>
            <vs-tr  :data="tr" :key="indextr" v-for="(tr, indextr) in data" >

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.name }}</p>
              </vs-td>

              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.code }}</p>
              </vs-td>
              <!-- <vs-td>
                  <vs-switch v-model="tr.status"></vs-switch>
              </vs-td> -->
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.camera_id }}</p>
              </vs-td>
               <vs-td>
                <ul>
                  <span @click="PalyCamera" ><li  :style="{background: tr.color_code}" class="w-4 h-4 round" /></span>
                </ul>
              </vs-td>
                <vs-td class="whitespace-no-wrap">
                 <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer " >
                  <div >
                    <feather-icon svgClasses="w-6 h-6 hover:text-primary stroke-current" class="ml-2" icon="MoreVerticalIcon" @click.stop=""></feather-icon>
                  </div>
                  <vs-dropdown-menu>
                  <vs-dropdown-item>
                <span class="flex items-center" @click="editCamera(tr)">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span> Edit </span>
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                <span class="flex items-center" @click="confirmDeleteCameraRecord(tr)">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                  <span>Delete</span>
                </span>
                </vs-dropdown-item>
                </vs-dropdown-menu>
                </vs-dropdown>
                </vs-td>
            </vs-tr>
          </tbody>
        </template>
    </vs-table>
    </div> 
  </div>
</template>
<script>
import moment from 'moment'
import {SINGLE_LOCATION,REMOVE_LOCATION,REMOVE_CAMERA,APPLLY_SCHEDULE_TO_CAMERAS,PLAY_CAMERA} from '@/graphql'
import DataViewSidebar from './addSidebarView.vue'
import AddCameraSiderbar from './addCameraSidebar'
import EditCameraSidebar from '../cameras/addSidebarView'





export default {
  name: "Location.vue",
  components: {
DataViewSidebar,
    'add-camera-sidebar': AddCameraSiderbar,
    'edit-camera-sidebar': EditCameraSidebar,

    
  },
  data: () => ({
    user_not_found: false,
    location:'',
    addNewDataSidebar: false,
    addNewCameraDataSidebar: false,
    sidebarData: {},
    DeletedItem:'',
    addNewCameraSidebar:false,
    cameraSidebarData: {},
    sidebarEditCameraData:{},
    IframeSrc:'',
    popupActive: false,
    rooms:[]




  }),
  filters: {
  formatDate: function (value) {
    if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
  },
    formatDates: function (value) {
    if (value) {
    return moment(String(value)).format('MM/DD/YYYY h:mm A')
  }
  },
 formatTime: function (value) {
    if (value) {
    return moment(String(value),'h:mm A').format('h:mm A')
  }
  }
},
   computed: {
      reset(){
       if(this.popupActive){
         return this.IframeSrc
       }
       if(!this.popupActive){
         return
       }
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
  },
methods: {
    PalyCamera(){
           this.$apollo
           .mutate({
            mutation: PLAY_CAMERA,
            variables: {
            id:'0',
           }
          })
            .then(response => {
              if (response) {
              this.IframeSrc=response.data.playCamera.embed_code
              this.popupActive=true
                          }
            }).catch(error => {
            console.log(error)
          });
    },
  confirmApplySchedule(location){
      this.DeletedItem=location
      this.$vs.dialog({
        type: 'confirm',
        color: 'warning',
        title: 'Confirm Action',
        text: `You are about to Apply "${location.name} " Schedule to all its Cameras`,
        accept: this.applySchedule,
        acceptText: 'Yes'
      })
  },
  applySchedule(){
       this.$apollo
      .mutate({
        mutation: APPLLY_SCHEDULE_TO_CAMERAS,
        variables: {
            id: this.DeletedItem.id,
            schedule_id:this.DeletedItem.schedule.id
          },
      })
      .then((response) => {
        this.get()
        this.StatusSuccess(response.data.applyScheduleToCameras.message,response.data.applyScheduleToCameras.color)
      });
  },
    getdata(value){
      if(value){
        this.get()
      }
    },
      toggleEditCameraDataSidebar (val = false) {
      this.addNewCameraDataSidebar = val
    },
     editCamera (data) {
      this.sidebarEditCameraData = data
      this.toggleEditCameraDataSidebar(true)
    },
     addCameraData (data) {
      this.cameraSidebarData = data
      this.toggleCameraSidebar(true)

    },
   toggleCameraSidebar (val = false) {
      this.addNewCameraSidebar = val
       if(!val){
         this.get()
      }
    },
      toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
      if(!val){
         this.get()
      }
    },
   editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    editCameraData (data) {
      this.sidebarCameraData = data
      this.toggleCameraSidebar(true)
    },
      confirmDeleteCameraRecord (camera) {
      this.DeletedItem=camera
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${camera.name} "`,
        accept: this.deleteDataCamera,
        acceptText: 'Delete'
      })
    },
    deleteDataCamera () {
    this.$apollo
      .mutate({
        mutation: REMOVE_CAMERA,
        variables: {
        id:  this.DeletedItem.id,
        schedule_id:this.DeletedItem.schedule.id
     },
      })
       .then(response => {
          this.get()
          if(response.data.deleteCamera.state=='Success'){
            this.StatusSuccess(response.data.deleteCamera.message,response.data.deleteCamera.color)
          }
          else{
            this.StatusSuccess(response.data.deleteCamera.message,response.data.deleteCamera.color)
          }
        }).catch(error => {
         console.log(error)
      });
   },

     confirmDeleteRecord (location) {
      this.DeletedItem=location
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${location.name}"`,
        accept: this.deleteData,
        acceptText: 'Delete'
      })
    },
     deleteData () {
      this.$apollo
      .mutate({
        mutation: REMOVE_LOCATION,
        variables: {
        id: this.DeletedItem.id,
        schedule_id:this.DeletedItem.schedule.id
          },
      })
        .then(response => {
          this.get()
          if(response.data.deleteLocation.status=='Success'){
            this.StatusSuccess(response.data.deleteLocation.message,response.data.deleteLocation.color)
            this.$router.push({ path: `/locations` })

          }
          else{
            this.StatusSuccess(response.data.deleteLocation.message,response.data.deleteLocation.color)
          }
        }).catch(error => {
         console.log(error)
      });
      // this.$store.dispatch('dataList/removeLocation', id).catch(err => { console.error(err) })
    },  
     StatusSuccess(status, color) {
      this.$vs.notify({
        title: "Location",
        text: status,
        color: color,
        position: 'top-right'
      })

    },
 get(){
      this.$apollo
         .mutate({
           mutation: SINGLE_LOCATION,
           variables: {
             id: this.$route.params.locationId,
           },
         })
         .then(response => {
           this.location = response.data.location
           var cameras_array=response.data.location.cameras
           var rooms=[]
          for (let index = 0; index < cameras_array.length; index++) {
           if(cameras_array[index].room){
             rooms.push(cameras_array[index].room)
           }
          }
        this.rooms=Object.values(rooms.reduce((acc,cur)=>Object.assign(acc,{[cur.id]:cur}),{}))         
      }).catch(error => {
          console.log(error)
      });

 }
    },
created(){
      this.img_cdn=process.env.VUE_APP_IMAGES_CDN_LINK
      this.lng=process.env.VUE_APP_I18N_LOCALE
      this.get()
},
 mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }


  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

  #demo-basic-card {
    .overlay-card {
        .vx-card__collapsible-content {
            max-height: 485px;
        }
    }

    .chat-card-log {
        height: 360px;

        .chat-sent-msg {
            background-color: #f2f4f7 !important;
        }
    }

    .card-video {
        .video-js {
            height: 370px;
        }
    }
  }
}

#demo-basic-card {
  margin-top: 1.5rem!important;
}
[data-letters]:before {
  content:attr(data-letters);
  display:block;
  border-radius: .25rem !important;
  font-size:100px;
  width: 100% !important;
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: none;
  text-transform: none;
  text-decoration: none;
  height:110px;
  line-height:110px;
  text-align:center;
}
 [data-lettersuser]:before {
  content:attr(data-lettersuser);
   }
  .studentuserdot{
  display:inline-block;
  font-size:50px;
  width:80px;
  height:80px;
  line-height:80px;
  text-align:center;
  border-radius:50%;
  vertical-align:middle;
  margin-right:1em;
  margin-left: 100px;
  margin-bottom: 30px;
  }
  .user_add_btn{
    float: right ;
    margin-top: -50px
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }

</style>